import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const ValidationWrapper = ({ children, validation }) => (
  <div className={'form-group' + (validation.isInvalid ? ' has-error' : '')}>
    {children(validation.isInvalid)}
    <span className="help-block">
      <FontAwesomeIcon icon={faExclamationCircle} style={{ marginRight: '.25em' }} />
      {validation.message}
    </span>
  </div>
);

export default ValidationWrapper;
